import React from 'react';
import './Textephotos0.css';

const Textephotos0= () => {
    return (
        <div className='mere2024'>

        <div className='containerA2024'>
            
            <div className='barres2024'>
            <div className='trait12024'></div>
            <div className='trait22024'></div>
            </div>
            <div className='titre2024'>
                <h1>TOUTES LES PHOTOS</h1>
            </div>
            <div className='ligne52024'>
            </div>
            </div>
            
   
    </div>
    
    );
};

export default Textephotos0;
